// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/directional-stability.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/directional-stability/directional-stability.js';

mount([g0]);
